import React from 'react';
import { useLocation } from 'react-router-dom';
import useBusinessTranslation from '../../../hooks/useBusinessTranslation';
import PageHeader from '../../components/misc/PageHeader';
import MarketplaceProductsPage from './MarketplaceProductsPage';
import ContributionPlansPage from './ContributionPlansPage';
import MerchantAccountPage from './MerchantAccountPage';

export default function SalesCollectPage(): JSX.Element {
  const { t } = useBusinessTranslation();
  const location = useLocation();

  // Set initial tab based on the current path or state
  const getInitialTab = (): 'contribution' | 'sales' | 'paymentSettings' => {
    // Check if state indicates which tab to show
    if (location.state?.activeTab) {
      return location.state.activeTab;
    }

    if (location.pathname.includes('/financial/contribution-plans')) {
      return 'contribution';
    }
    if (location.pathname.includes('/financial/merchantAccount')) {
      return 'paymentSettings';
    }
    if (
      location.pathname.includes('/financial/products') ||
      location.pathname.includes('/financial/orders')
    ) {
      return 'sales';
    }
    return 'contribution';
  };

  const [activeTab, setActiveTab] = React.useState<'contribution' | 'sales' | 'paymentSettings'>(
    getInitialTab(),
  );

  // Respond to navigation that updates location.state without changing the path
  React.useEffect(() => {
    if (location.state?.activeTab && location.state.activeTab !== activeTab) {
      setActiveTab(location.state.activeTab);
    }
  }, [location.state]);

  return (
    <>
      <div>
        <PageHeader
          title={t('page.financial.salesCollect.title')}
          subtitle={t('page.financial.salesCollect.subtitle')}
        />

        {/* Tabs */}
        <div className="mb-6 flex gap-4 border-b border-primary-300">
          {(['contribution', 'sales', 'paymentSettings'] as const).map((tabKey) => (
            <button
              key={tabKey}
              type="button"
              onClick={() => setActiveTab(tabKey)}
              className={`relative px-4 pb-1 pt-2 font-medium transition-all duration-150 ${
                activeTab === tabKey
                  ? 'text-primary-700 -mb-[1px] rounded-t-md border border-primary-300 border-b-secondary-50'
                  : 'text-primary-600 hover:text-primary-800'
              }`}>
              {t(`page.financial.salesCollect.tabs.${tabKey}`)}
            </button>
          ))}
        </div>

        <div className="w-full">
          {activeTab === 'sales' && <MarketplaceProductsPage hideHeader />}
          {activeTab === 'contribution' && <ContributionPlansPage hideHeader />}
          {activeTab === 'paymentSettings' && <MerchantAccountPage hideHeader />}
        </div>
      </div>
    </>
  );
}
